import React, {useEffect, useState} from 'react';
import { Col, Container, Row } from 'reactstrap';
import modelVenue from '../../Models/Venue';
import { useParams } from 'react-router-dom';
import {setVenueData, showVenueMenu} from '../../redux/actions/venueActions';
import {connect} from "react-redux";
import Images from "./components/Images";
import ModalUploadImage from "./components/ModalUploadImage";
import {showNotification} from "../../shared/components/Notification";

const VenuePhotos = ({ dispatch, venueData,venueImages,rtl,theme }) => {
    const { venueId } = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const vm = new modelVenue();

    useEffect(() => {
        dispatch(showVenueMenu(true));

        vm.getVenueData(venueId).then(async response => {
            if (response.data.status === 'failed') {
                alert('failed');
                return false;
            }
            return true;
        });

        vm.getVenueImages(venueId).then(response => {
            if (response.data.status === "failed") {
                showNotification(theme,'danger',rtl,'Get Images',response.data.msg);
                return false;
            }
            setIsLoaded(true);
            return true;
        });

    },[venueId]);

    return (
        isLoaded && (
            <Container className="dashboard">
                <Row className={"pb-2"}>
                    <Col md={12}>
                        <h3 className="page-title">{venueData.v_name}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3} className={'mb-4'}>
                        <ModalUploadImage />
                    </Col>
                </Row>
                <Row>
                    {isLoaded &&
                        <Images/>
                    }
                </Row>
            </Container>
        )
    );
}

export default connect(state => ({
    rtl: state.rtl,
    theme: state.theme,
    venueData:state.venue.venueData,
    venueImages:state.venue.venueImages,
    showVenueMenu:state.venue.showVenueMenu
}))(VenuePhotos);